import actions from "./actions";

const {FETCH_GALLERY, FETCH_GALLERIES, RESET_GALLERY} = actions;
const initState = {
    galleries: {
        page: 0,
         perPage: 35,
        data: [],
        total: 0
    },
    gallery: {_id: null}
};

const GalleryReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_GALLERIES:
            return {
                ...state,
                galleries: data
            }
        case RESET_GALLERY:
            return {
                ...state,
                gallery: initState.gallery,
            };
        case FETCH_GALLERY:
            return {
                ...state,
                gallery: data,
            };
        default:
            return state;
    }
}

export default GalleryReducer;
